var websocket;

const levels = Object.freeze({
  error: 0,
  warn: 1,
  info: 2,
  http: 3,
  verbose: 4,
  debug: 5,
  silly: 6,
}); //npm log levels (There really is a 'silly' level)
var logLevel = levels.error;

const logFunctions = {
  error: function () {
    if (levels.error <= logLevel) {
      console.error.apply(console, arguments);
      sendLogs(Array.prototype.slice.call(arguments), "error");
    }
  },
  warn: function () {
    if (levels.warn <= logLevel) {
      console.warn.apply(console, arguments);
      sendLogs(arguments, "warning");
    }
  },
  info: function () {
    if (levels.info <= logLevel) {
      console.info.apply(console, arguments);
      sendLogs(arguments, "info");
    }
  },
  verbose: function () {
    if (levels.verbose <= logLevel) {
      console.log.apply(console, arguments);
      sendLogs(arguments, "verbose");
    }
  },
  http: function () {
    if (levels.http <= logLevel) {
      console.log.apply(console, arguments);
      sendLogs(arguments, "http");
    }
  },
  debug: function () {
    if (levels.debug <= logLevel) {
      console.debug.apply(console, arguments);
      sendLogs(arguments, "debug");
    }
  },
  silly: function () {
    if (levels.silly <= logLevel) {
      console.log.apply(console, arguments);
      sendLogs(arguments, "silly");
    }
  },

  setLevel: function (newLevel) {
    newLevel = newLevel.toLowerCase();
    if (Object.values(levels).includes(levels[newLevel])) {
      logLevel = levels[newLevel];
      console.info("Logging_setLevel() => Set new loglevel to: ", logLevel);
    } else {
      console.error(
        "Logging_setLevel() => %s is not a valid log level",
        newLevel
      );
    }
  },

  setWebsocket: function (newWebsocket) {
    websocket = newWebsocket;
  },

  getLogLevel: function () {
    return logLevel;
  },
};

function sendLogs(message, level) {
  var messageString = "";
  Object.values(message).forEach((val) => {
    messageString += val;
  });

  if (typeof websocket !== "undefined" && websocket?.ws?.readyState === 1) {
    websocket.sendLogs(messageString, level);
  } else {
    //No websocket connection is established
  }
}

module.exports = { logFunctions };
